/* ============================================================================
   HYT L4 | page behaviour: buybox, gallery, accordions, review carousel, sticky.

   Every price, cadence and saving is derived from window.PC_HYT at render time.
   Nothing in this file hardcodes a number, so the page cannot drift from the
   product data module, and updating the module updates the page.
   ========================================================================== */
(function () {
  'use strict';

  var P = window.PC_HYT;
  if (!P) { console.error('hytl4: PC_HYT missing'); return; }

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* -------------------------------------------------------------- buybox */
  var bb = $('[data-bb]');

  /* Defaults come from the theme section settings when the page is running inside
     the PC theme (the wrapper carries data-default-*), and fall back to the
     standalone page's own defaults. A size the store has marked sold out is never
     opened on, whatever the setting says. */
  var root = document.querySelector('.hytl4');
  var wantSize = (root && root.getAttribute('data-default-size')) || 'value';
  var wantMode = (root && root.getAttribute('data-default-mode')) || 'sub';
  if (!P.byKey(wantSize)) wantSize = 'value';
  if (P.byKey(wantSize).soldOut) {
    var alt = P.sizes.filter(function (x) { return !x.soldOut; })[0];
    if (alt) wantSize = alt.key;
  }
  var state = { mode: wantMode === 'once' ? 'once' : 'sub', size: wantSize, busy: false };

  var rowsEl  = $('[data-rows]', bb);
  var checkEl = $('[data-check]', bb);
  var errEl   = $('[data-err]', bb);
  var footEl  = $('[data-foot]', bb);
  var atcEl   = $('[data-atc]', bb);
  var atcLbl  = $('[data-atc-label]', bb);
  var titleEl = $('[data-card-title]', bb);
  var subEl   = $('[data-card-sub]', bb);
  var altEl   = $('[data-alt]', bb);

  function size() { return P.byKey(state.size); }
  function sub()  { return state.mode === 'sub'; }
  function price(s, isSub) { return P.priceOf(s || size(), isSub === undefined ? sub() : isSub); }

  function buildRows() {
    rowsEl.innerHTML = P.sizes.map(function (s) {
      var now  = price(s);
      var apart = P.pct(s.apart, now);
      return '' +
      '<label class="hytl4-row" data-size="' + s.key + '" data-on="0">' +
        (s.popular ? '<span class="hytl4-pop">Most popular</span>' : '') +
        '<input type="radio" name="hytl4-size" value="' + s.key + '">' +
        '<span class="hytl4-row-top">' +
          '<span class="hytl4-row-name">' + esc(s.label) +
            '<b data-r-cycle></b>' +
          '</span>' +
          '<span class="hytl4-row-badge" data-r-badge>' + apart + '% less</span>' +
        '</span>' +
        '<span class="hytl4-row-price">' +
          '<span class="hytl4-row-now" data-r-now></span>' +
          '<span class="hytl4-row-was" data-r-was></span>' +
          '<span class="hytl4-row-day" data-r-day></span>' +
        '</span>' +
        '<span class="hytl4-row-caps">' + esc(s.contents) + '</span>' +
      '</label>';
    }).join('');

    $$('.hytl4-row', rowsEl).forEach(function (row) {
      row.addEventListener('click', function () {
        var picked = P.byKey(row.getAttribute('data-size'));
        if (picked.soldOut) return;
        state.size = picked.key;
        render();
      });
    });
  }

  function render() {
    var s = size(), isSub = sub();

    /* rows */
    $$('.hytl4-row', rowsEl).forEach(function (row) {
      var rs  = P.byKey(row.getAttribute('data-size'));
      var now = price(rs);
      row.setAttribute('data-on', rs.key === s.key ? '1' : '0');
      row.setAttribute('data-soldout', rs.soldOut ? '1' : '0');
      $('input', row).checked = rs.key === s.key;
      $('[data-r-cycle]', row).textContent = rs.supply + (isSub ? ', ' + rs.cadenceLabel : '');
      $('[data-r-now]', row).textContent   = P.money(now);
      var was = $('[data-r-was]', row);
      if (isSub) { was.textContent = P.money(rs.once); was.hidden = false; }
      else       { was.textContent = ''; was.hidden = true; }
      $('[data-r-day]', row).textContent   = P.perDay(now, rs) + ' a day';
      $('[data-r-badge]', row).textContent = rs.soldOut
        ? 'Sold out' : P.pct(rs.apart, now) + '% less';
    });

    /* card head */
    titleEl.firstChild.nodeValue = isSub ? 'Choose your cycle' : 'Choose your size';
    subEl.textContent = isSub
      ? 'Delivered ' + s.cadenceLabel + '. Pause, skip or cancel anytime.'
      : 'A single delivery. No subscription, no renewal.';

    /* checklist, state driven so it can never promise the wrong thing */
    var now = price(s);
    var qualifies = now >= P.freeShipMin;
    var items = [
      '<b>' + P.pct(s.apart, now) + '% less</b> than the two bottles bought separately (' +
        P.money(s.apart) + ' apart)',
      qualifies
        ? 'Free shipping, this order clears the $' + P.freeShipMin + ' threshold'
        : 'Shipping is charged, ' + P.money(now) + ' is under the $' + P.freeShipMin + ' free shipping threshold',
      isSub
        ? 'Renews ' + s.cadenceLabel + ' at ' + P.money(s.sub) + '. Pause, skip or cancel anytime.'
        : 'One delivery only. Nothing renews.',
      '60 day money back guarantee on both bottles',
      s.caps.map(function (c) { return c[0] + ', ' + c[1]; }).join(' and ')
    ];
    checkEl.innerHTML = items.map(function (t) {
      return '<li>' + TICK + '<span>' + t + '</span></li>';
    }).join('');

    /* cta + foot */
    var dead = !!s.soldOut;
    atcEl.setAttribute('aria-disabled', dead ? 'true' : 'false');
    atcLbl.textContent = dead
      ? 'Sold out'
      : (isSub ? 'Start Now, ' + P.money(now) : 'Add to cart, ' + P.money(now));
    footEl.textContent = isSub
      ? 'Then ' + P.money(s.sub) + ' ' + s.cadenceLabel + ', ' + P.perDay(s.sub, s) + ' a day. Cancel anytime.'
      : P.perDay(s.once, s) + ' a day across a ' + s.supply.replace(' supply', '') + ' cycle.';

    /* the mirror of the reference "Try Once" card: whichever purchase type is NOT
       currently selected. otherIsSub is that card's own mode, not this one's. */
    var otherIsSub = !isSub, otherPrice = price(s, otherIsSub);
    $('[data-alt-title]', altEl).textContent = otherIsSub
      ? 'Subscribe instead and save 15%' : 'Rather buy it once?';
    $('[data-alt-sub]', altEl).textContent = otherIsSub
      ? 'Same box, ' + P.perDay(otherPrice, s) + ' a day, cancel anytime'
      : 'One delivery, ' + P.perDay(otherPrice, s) + ' a day, no renewal';
    $('[data-alt-price]', altEl).textContent = P.money(otherPrice);
    $('[data-alt-btn]', altEl).textContent = otherIsSub ? 'Subscribe' : 'Buy once';
    altEl.hidden = false;

    /* sticky */
    $('[data-sticky-title]').textContent = s.label;
    $('[data-sticky-sub]').textContent = P.money(now) +
      (isSub ? ' ' + s.cadenceLabel : ' one time') + ', ' + P.perDay(now, s) + ' a day';
    $('[data-sticky-btn]').textContent = isSub ? 'Start Now' : 'Add to cart';
  }

  $$('[data-mode]', bb).forEach(function (b) {
    b.addEventListener('click', function () {
      state.mode = b.getAttribute('data-mode');
      $$('[data-mode]', bb).forEach(function (x) {
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      render();
    });
  });

  function add(isSub) {
    if (state.busy) return;
    if (size().soldOut) { errEl.textContent = 'That size is sold out right now.'; return; }
    state.busy = true;
    errEl.textContent = '';
    var restore = atcLbl.textContent;
    atcLbl.textContent = 'Adding...';
    Promise.resolve(P.addToCart(size(), isSub))
      .then(function (r) {
        if (r && r.offStore) {
          errEl.textContent = '';
          footEl.textContent = 'Opened the live product page in a new tab. The cart only works on physicianschoice.com.';
        }
      })
      .catch(function (e) {
        errEl.textContent = 'Something went wrong adding that. Please try again.';
        console.error(e);
      })
      .then(function () {
        state.busy = false;
        atcLbl.textContent = restore;
      });
  }

  atcEl.addEventListener('click', function (e) { e.preventDefault(); add(sub()); });
  $('[data-sticky-btn]').addEventListener('click', function (e) { e.preventDefault(); add(sub()); });
  $('[data-alt-btn]', altEl).addEventListener('click', function () { add(!sub()); });

  $$('[data-mode]', bb).forEach(function (x) {
    x.setAttribute('aria-pressed', x.getAttribute('data-mode') === state.mode ? 'true' : 'false');
  });

  buildRows();
  render();

  /* -------------------------------------------------------------- gallery */
  var galMain = $('[data-gal-main]');
  $$('[data-gal-thumbs] button').forEach(function (b) {
    b.addEventListener('click', function () {
      galMain.src = b.getAttribute('data-src');
      $$('[data-gal-thumbs] button').forEach(function (x) {
        x.setAttribute('aria-selected', x === b ? 'true' : 'false');
      });
    });
  });

  /* ------------------------------------------------- supplement facts popup
     Desktop shows both panels side by side. Narrow screens get one panel per
     pane, story style: swipe to move, segment bars show and set position, and a
     small CTA keeps the offer one tap away. */
  var facts     = $('[data-facts]');
  var factsBox  = facts && $('.hytl4-facts-box', facts);
  var factTrack     = facts && $('[data-facts-track]', facts);
  var factBars      = facts ? $$('[data-facts-go]', facts) : [];
  var prevBtn   = facts && $('[data-facts-prev]', facts);
  var nextBtn   = facts && $('[data-facts-next]', facts);
  var opener    = $('[data-facts-open]');
  var lastFocus = null;

  function paneCount() { return factTrack ? factTrack.children.length : 0; }

  function currentPane() {
    if (!factTrack || !factTrack.children.length) return 0;
    var w = factTrack.children[0].getBoundingClientRect().width || 1;
    return Math.round(factTrack.scrollLeft / w);
  }

  function paintFacts() {
    var i = currentPane(), n = paneCount();
    factBars.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (prevBtn) prevBtn.disabled = i <= 0;
    if (nextBtn) nextBtn.disabled = i >= n - 1;
  }

  function goPane(i) {
    if (!factTrack || !factTrack.children[i]) return;
    var w = factTrack.children[0].getBoundingClientRect().width || 0;
    factTrack.scrollTo({ left: i * w, behavior: 'smooth' });
    /* scroll events settle late, so paint from the intent as well */
    factBars.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (prevBtn) prevBtn.disabled = i <= 0;
    if (nextBtn) nextBtn.disabled = i >= paneCount() - 1;
  }

  function openFacts() {
    if (!facts) return;
    lastFocus = document.activeElement;
    facts.hidden = false;
    facts.setAttribute('data-open', '1');
    document.body.classList.add('hytl4-lock');
    if (factTrack) factTrack.scrollLeft = 0;
    paintFacts();
    var x = $('[data-facts-close]', factsBox);
    if (x) x.focus();
  }

  function closeFacts() {
    if (!facts) return;
    facts.setAttribute('data-open', '0');
    facts.hidden = true;
    document.body.classList.remove('hytl4-lock');
    /* Focus goes back to the button that owns this dialog, not to whatever happened
       to be focused when it opened. There is exactly one opener, so that is always
       where the reader was, and it keeps the behaviour deterministic. */
    var back = opener || lastFocus;
    if (back && back.focus) back.focus();
  }

  function warmPanels() {
    if (!factTrack) return;
    $$('img[loading="lazy"]', factTrack).forEach(function (i) { i.loading = 'eager'; });
  }
  if (opener) {
    opener.addEventListener('click', openFacts);
    ['pointerenter', 'focus', 'touchstart'].forEach(function (ev) {
      opener.addEventListener(ev, warmPanels, { once: true, passive: true });
    });
  }
  if (facts) {
    $$('[data-facts-close]', facts).forEach(function (b) {
      b.addEventListener('click', closeFacts);
    });
    factBars.forEach(function (b) {
      b.addEventListener('click', function () { goPane(+b.getAttribute('data-facts-go')); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goPane(currentPane() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goPane(currentPane() + 1); });
    if (factTrack) factTrack.addEventListener('scroll', paintFacts, { passive: true });
    var factCta = $('[data-facts-cta]', facts);
    if (factCta) factCta.addEventListener('click', closeFacts);   /* the href does the scrolling */

    document.addEventListener('keydown', function (e) {
      if (facts.getAttribute('data-open') !== '1') return;
      if (e.key === 'Escape') { closeFacts(); return; }
      if (e.key === 'ArrowRight') goPane(currentPane() + 1);
      if (e.key === 'ArrowLeft') goPane(currentPane() - 1);
    });
  }

  /* ---------------------------------------------------- reviews and ratings */
  var data = {};
  try { data = JSON.parse($('#hytl4-reviews').textContent); }
  catch (e) { console.error('hytl4: review block unreadable', e); }

  var track = $('[data-say-track]');
  if (track && data.featured) {
    track.innerHTML = data.featured.map(function (r) {
      return '' +
      '<article class="hytl4-say-card">' +
        '<div class="hytl4-say-stars" aria-label="' + r.rating + ' out of 5">' +
          new Array(r.rating + 1).join('★') + '</div>' +
        (r.title && !/^\d\sStars?$/i.test(r.title)
          ? '<h3 class="hytl4-say-title">' + esc(r.title) + '</h3>' : '') +
        '<p class="hytl4-say-body">' + esc(r.body) + '</p>' +
        '<p class="hytl4-say-meta"><b>' + esc(r.name || 'Anonymous') + '</b>' +
          '<span>Review of ' + esc(r.product) + (r.variant ? ', ' + esc(r.variant) : '') + '</span>' +
          '<span>' + esc(r.date) + '</span>' +
        '</p>' +
      '</article>';
    }).join('');
  }
  function scrollTrack(dir) {
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 16 : 300;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }
  var prev = $('[data-say-prev]'), next = $('[data-say-next]');
  if (prev) prev.addEventListener('click', function () { scrollTrack(-1); });
  if (next) next.addEventListener('click', function () { scrollTrack(1); });

  var bundle = data.aggregates && data.aggregates['Hack Your Tummy Bundle'];
  if (bundle) {
    $('[data-rate-avg]').textContent   = bundle.rating;
    $('[data-rate-count]').textContent = bundle.count + ' reviews of the bundle';
  }
  if (data.sampled) $('[data-rate-sample]').textContent = data.sampled;

  var bars = $('[data-bars]'), dist = data.sampleDistribution || {};
  if (bars) {
    var total = Object.keys(dist).reduce(function (t, k) { return t + dist[k]; }, 0) || 1;
    bars.innerHTML = [5, 4, 3, 2, 1].map(function (n) {
      var c = dist[String(n)] || 0, w = (c / total * 100).toFixed(1);
      return '<div><span>' + n + '★</span><s><i style="width:' + w + '%"></i></s><span>' + c + '</span></div>';
    }).join('');
  }

  var agg = $('[data-agg]');
  if (agg && data.aggregates) {
    agg.innerHTML = Object.keys(data.aggregates).map(function (k) {
      var a = data.aggregates[k];
      return '<div><b>' + a.rating + ' out of 5</b><span>' + esc(k) + ', ' +
             a.count.toLocaleString('en-US') + ' reviews</span></div>';
    }).join('');
  }

  /* ------------------------------------------------------- offer anchors
     Every reason block closes with a link to #offer, and that is the money moment,
     so it should land on the top of the block every time. */
  var offerEl = document.getElementById('offer');
  $$('a[href="#offer"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!offerEl) return;
      e.preventDefault();
      /* two frames: let any reflow from the click settle before measuring */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var y = offerEl.getBoundingClientRect().top + window.pageYOffset - 8;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        });
      });
    });
  });

  /* ---------------------------------------------------------------- ticker */
  var tick = $('[data-ticker]');
  if (tick) tick.appendChild(tick.firstElementChild.cloneNode(true));   /* seamless loop */

  /* ---------------------------------------------------------------- sticky */
  /* An IntersectionObserver alone never fires on a page that loads at the top,
     so the flag it sets is applied from a scroll listener as well. */
  var stickyEl = $('[data-sticky]');
  var offer = $('#offer');
  var narrow = window.matchMedia('(max-width: 900px)');
  var offerVisible = false;

  if ('IntersectionObserver' in window && offer) {
    new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { offerVisible = e.isIntersecting; });
      paint();
    }, { threshold: 0 }).observe(offer);
  }

  function paint() {
    var pastHero = window.scrollY > 420;
    var show = narrow.matches && pastHero && !offerVisible;
    stickyEl.setAttribute('data-show', show ? '1' : '0');
  }
  window.addEventListener('scroll', paint, { passive: true });
  window.addEventListener('resize', paint);
  paint();
})();
